import io from "socket.io-client";

export const Socket = io.connect("https://socket.taxsuvidhaa.com");
const room = "taxsuvidha"
export const sendSocketApproval = () => {
    try {
        Socket.on("connect", () => {
            Socket.emit("approve_connection", room)
        })
    } catch (err) {
        console.log(err)
    }
}

export const pushNotification = (client) => {
    try {
        const room = {
            room: "taxsuvidha"
        }
        const obj = {
            ...client,
            ...room
        }
        Socket.emit("from_client", obj)
    } catch (error) {

    }
}